var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z",
    fill: "#00E676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50216 3.00833L13.4584 7.01768L9.50036 11.0246L7.91692 9.42186L10.2919 7.01768L9.50036 6.21612L6.33348 9.42186L9.50036 12.6276L14.2503 7.81886L15.8334 9.42186L9.50036 15.8333L3.16675 9.42186L9.50216 3.00833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49998 18.6833C14.5718 18.6833 18.6833 14.5718 18.6833 9.50001C18.6833 4.4282 14.5718 0.316681 9.49998 0.316681C4.42817 0.316681 0.31665 4.4282 0.31665 9.50001C0.31665 14.5718 4.42817 18.6833 9.49998 18.6833Z",
    stroke: "#00E676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgLogo);
export default __webpack_public_path__ + "static/media/NRGLogo.4a401f88d244092661227000fdcb206b.svg";
export { ForwardRef as ReactComponent };